/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Fullcalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import Table from "components/Table/TableAppoint";
import Pagination from "react-responsive-pagination";

// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js"; // แก้ไข import ให้ถูกต้อง
import loading from "assets/img/loading-load.gif";

import "react-datetime/css/react-datetime.css"
import "./custom-style.css";


const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none"
    }
};

const _color = [{ id: 1, forecolor: '#3788d8' }, { id: 2, forecolor: '#0E6251' }, { id: 3, forecolor: '#9A7D0A' }, { id: 4, forecolor: '#8E44AD' }, { id: 5, forecolor: '#E67E22' }, { id: 6, forecolor: '#6D4C41' }]

const useStyles = makeStyles(styles);


const Appointment = (props) => {
    var moment = require('moment');
    require('moment/locale/th');
    const [leaveAll, setLeaveAll] = useState([]);
    const [DefaultDate, setDefaultDate] = useState(moment().format("YYYY-MM-DD"));
    const [arrAppoint, setArrAppoint] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [DisabledDatetime, setDisabledDatetime] = useState("");
    const [DisabledDatetimeShow, setDisabledDatetimeShow] = useState("");
    const [serviceUnitKey, setServiceUnitKey] = useState(0);
    const [ServiceUnitName, setServiceUnitName] = useState("");
    const [tableHead, setTableHead] = useState([]);
    const [pageSize] = useState(100);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const windowWidth = useWindowWidth();


    useEffect(() => { }, [currentPage])

    function useWindowWidth() {
        const [windowWidth, setWindowWidth] = useState(window.innerWidth - 400);

        useEffect(() => {
            const resizeHandler = () => {
                setWindowWidth(window.innerWidth - 400);
            };

            window.addEventListener("resize", resizeHandler);
            return () => {
                window.removeEventListener("resize", resizeHandler);
            };
        }, []);
        return windowWidth;
    }

    // ใช้ useRef แทน createRef ใน Functional Component
    const calendarRef = useRef(null);

    // ห่อ getMeeting ด้วย useCallback เพื่อแก้ปัญหา dependency
    const getMeeting = useCallback((e, data) => {
        var month = e.getUTCMonth() + 1;
        // แก้ไข: == เป็น ===
        if (data === 2) {
            month = e.getUTCMonth() + 2;
        }
        // แก้ไข: == เป็น ===
        if (data === 3) {
            month = e.getUTCMonth() + 2;
        }
        let year = e.getUTCFullYear();

        axios.post('/api/v1/opd/appoint', { year: year, month: month })
            .then(
                result => {
                    const temp = [];
                    var data = result.data.data;
                    if (data.length >= 0) {
                        for (let i = 0; i < data.length; i++) {
                            var newObj = {
                                name: data[i].ServiceUnitName + " " + data[i].PatientCount
                                , fromDT: data[i].AppointDate
                                , toDT: data[i].AppointDate
                                , serviceUnitKey: data[i].ServiceUnitKey
                            }
                            temp.push(newObj);
                        }
                    }
                    var json = JSON.parse(JSON.stringify(temp).split('"name":').join('"title":').split('"fromDT":').join('"start":')
                        .split('"toDT":').join('"end":').split('"serviceUnitKey":').join('"id":'));
                    if (json.length >= 0) {
                        setLeaveAll([]);
                        setLeaveAll(json);
                    }

                },
                error => { alert(error); }
            );
    }, []);

    useEffect(() => {
        // แก้ไข: != เป็น !==
        if (DefaultDate !== null && DefaultDate !== '') {
            if (calendarRef.current) {
                let calendarApi = calendarRef.current.getApi();
                calendarApi.gotoDate(DefaultDate);
            }
        }
    }, [DefaultDate]); // เพิ่ม calendarRef ถ้าจำเป็น แต่ปกติ ref ไม่ต้องใส่

    useEffect(() => {
        // แก้ไข: ใช้ setTableHead แทน .push
        setTableHead(["HN", "ชื่อ - สกุล", "เบอร์โทรศัพท์", "สถานะ"]);

        if (calendarRef.current) {
            let calendarApi = calendarRef.current.getApi();
            getMeeting(calendarApi.getDate());
        }
    }, [getMeeting]); // เพิ่ม getMeeting เป็น dependency

    useEffect(() => {
        // แก้ไข: != เป็น !==
        if (serviceUnitKey !== 0) {
            axios.post('/api/v1/opd/appointbydate', { appointDate: DisabledDatetime, serviceUnitKey: serviceUnitKey })
                .then(
                    result => {
                        var tableList = [];
                        if (result.data.data.length > 0) {
                            result.data.data.forEach(e => {
                                tableList.push([e.HN, e.FullName, e.MobilePhone, e.Appoint]);
                            });
                        }

                        setArrAppoint(tableList);
                        // แก้ไข: ใช้ pageSize จาก state โดยตรง (ไม่ต้อง .value ถ้าเป็นค่า number)
                        var total = result.total / pageSize;
                        if (!Number.isInteger(total)) {
                            setTotalPages((total | 0) + 1);
                        } else if (total === 0) {
                            setTotalPages(1);
                        } else {
                            setTotalPages(total);
                        }
                    }
                )
        }
    }, [serviceUnitKey, DisabledDatetime, pageSize]); // เพิ่ม dependencies ที่ขาดหายไป


    const handleDateClick = (args) => {

    };

    const handleEventClick = (args) => {
        setDefaultDate(moment(args.event.start).format('YYYY-MM-DD'))
        setDisabledDatetime(moment(args.event.start).format('YYYY-MM-DD'))
        const thaiDate = moment(args.event.start).toDate().toLocaleDateString('th-TH', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
        setDisabledDatetimeShow(thaiDate);
        setServiceUnitKey(args.event._def.publicId);
        var name = args.event._def.title;
        const words = name.split(" ");
        setServiceUnitName(words[0]);
    };


    const classes = useStyles();
    return (

        <div>
            <Grid>
                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary">
                            <Grid>
                                <Col xs={6} sm={6} md={3}>
                                    <h4 className={classes.cardTitleWhite}>จัดการวันปิดบริการ</h4>
                                </Col>
                                <Col xs={6} sm={6} md={6} style={{ color: 'black', textAlign: 'left' }}>
                                </Col>
                            </Grid>
                        </CardHeader>
                        <CardBody>
                            <Grid>
                                {isLoading && (
                                    <>
                                        <Col xs={12} sm={12} md={12} style={{ textAlign: "center" }}>
                                            <img style={{ width: "50%" }} src={loading} alt="..." />
                                        </Col>
                                    </>
                                )}
                                {!isLoading && (<>
                                    <Col xs={12} sm={12} md={6}>
                                        <div style={{ textAlign: 'center' }}>
                                            <Fullcalendar
                                                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                                ref={calendarRef}
                                                initialView={"dayGridMonth"}
                                                headerToolbar={{
                                                    start: "title", // will normally be on the left. if RTL, will be on the right
                                                    center: "",
                                                    end: "myCustomButton,myCustomButton2,myCustomButton3", // will normally be on the right. if RTL, will be on the left
                                                }}
                                                hiddenDays={[0]}
                                                height={"100vh"}
                                                dateClick={handleDateClick}
                                                events={leaveAll}
                                                droppable={true}
                                                rerenderDelay={10}
                                                eventDurationEditable={false}
                                                //editable={true}
                                                //eventClick={}
                                                eventClick={handleEventClick}
                                                customButtons={{
                                                    myCustomButton: {
                                                        text: 'today',
                                                        click: function () {
                                                            let calendarApi = calendarRef.current.getApi();
                                                            calendarApi.today();
                                                            getMeeting(calendarApi.getDate(), 1);
                                                        }
                                                    },
                                                    myCustomButton2: {
                                                        text: '<',
                                                        click: function () {
                                                            let calendarApi = calendarRef.current.getApi();
                                                            calendarApi.prev();
                                                            getMeeting(calendarApi.getDate(), 2);
                                                        }
                                                    },
                                                    myCustomButton3: {
                                                        text: '>',
                                                        click: function () {
                                                            let calendarApi = calendarRef.current.getApi();
                                                            calendarApi.next();
                                                            getMeeting(calendarApi.getDate(), 3);
                                                        }
                                                    },
                                                }}
                                                locale={'th'}
                                                eventContent={renderEventContent}
                                                displayEventTime={false}
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={12} md={6} style={{ marginTop: "58px" }}>

                                        <Card>
                                            <CardHeader color="info">
                                                <h4 className={classes.cardTitleWhite}>รายชื่อผู้ป่วยนัด {ServiceUnitName} ในวันที่ {DisabledDatetimeShow}</h4>
                                                <p className={classes.cardCategoryWhite}>
                                                </p>
                                            </CardHeader>
                                            <CardBody>
                                                <Table
                                                    tableHeaderColor="info"
                                                    tableHead={tableHead}
                                                    tableData={arrAppoint}
                                                />
                                            </CardBody>
                                            <CardFooter>
                                                <Pagination
                                                    current={currentPage}
                                                    total={totalPages}
                                                    onPageChange={setCurrentPage}
                                                    maxWidth={windowWidth}
                                                />
                                            </CardFooter>
                                        </Card>
                                    </Col>

                                </>)
                                }
                            </Grid>
                        </CardBody>
                        <CardFooter>

                        </CardFooter>
                    </Card>
                </Col>
            </Grid>
        </div>
    );


    function renderEventContent(eventInfo) {

        const _c = _color.find(c => c.id === 1);
        // แก้ไข: == เป็น ===
        const colorTxt = (_c !== undefined) ? ((eventInfo.event.extendedProps.isDisabled === false) ? 'red' : _c.forecolor) : '#000000';

        // แก้ไข: == เป็น ===
        const strikeTxt = (eventInfo.event.extendedProps.isDisabled === false) ? 'line-through' : '';

        return (
            <>
                <div className="fc-event-time" style={{ color: colorTxt, textDecoration: strikeTxt }}> {eventInfo.timeText}</div>
                <div className="fc-event-title" style={{ color: colorTxt, textDecoration: strikeTxt }}> {eventInfo.event.title}</div>
            </>
        )
    }
}

export default Appointment;